import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Editions from './pages/Editions';
import Registration from './pages/Registration';
import Media from './pages/Media';
import Events from './pages/Events';
import Contact from './pages/Contact';
import ArticlePage from './pages/ArticlePage';
import Team from './pages/Team';
import AdvisoryBoard from './pages/AdvisoryBoard';
import PrivacyTerms from './pages/PrivacyTerms';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/*" element={<About />} />
            <Route path="/editions" element={<Editions />} />
            <Route path="/events" element={<Events />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/media" element={<Media />} />
            <Route path="/media/*" element={<Media />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/team" element={<Team />} />
            <Route path="/advisory-board" element={<AdvisoryBoard />} />
            <Route path="/privacy-terms" element={<PrivacyTerms />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
